import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "カフェレオ(在庫あり)" },
  { value: 3, text: "カフェレオ(在庫なし)" },
  { value: 2, text: "メーカー" },
]);
